import { render, staticRenderFns } from "./despachos-hora.vue?vue&type=template&id=4c093c7c&scoped=true&"
import script from "./despachos-hora.vue?vue&type=script&lang=js&"
export * from "./despachos-hora.vue?vue&type=script&lang=js&"
import style0 from "./despachos-hora.vue?vue&type=style&index=0&id=4c093c7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c093c7c",
  null
  
)

export default component.exports